import React, { useState } from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { ChevronDown } from './Icons/index.js';
const isBranch = (option) => {
    return 'children' in option;
};
const TreeSelect = (props) => {
    const [path, setPath] = useState([]);
    const [open, setOpen] = useState(false);
    let options = Array.isArray(props.options)
        ? props.options
        : props.options.children;
    for (const index of path) {
        const option = options[index];
        if (isBranch(option)) {
            options = option.children;
        }
    }
    return (React.createElement(Wrapper, { onBlur: () => {
            setOpen(false);
        } },
        React.createElement(Selected, { onClick: () => {
                setOpen(!open);
            } },
            props.value.label,
            React.createElement(ChevronDown, null)),
        open && (React.createElement(Select, null, options.map((option, index) => {
            if (!isBranch(option)) {
                return (React.createElement(Leaf, { key: index, onClick: () => {
                        props.onChange(option.value);
                        setOpen(false);
                    } }, option.label));
            }
            return (React.createElement(Branch, { key: index, onClick: () => {
                    setPath([...path, index]);
                } }, option.label));
        })))));
};
const Wrapper = styled.div `
  position: relative;
  display: inline;
`;
const Selected = styled.div `
  border-bottom: 2px solid #7568f6;
  display: inline-block;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;
const Select = styled.div `
  position: absolute;
  left: 0;
  top: 20px;
  max-height: 200px;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 100;
`;
const Leaf = styled.div `
  cursor: pointer;
  padding: 0.5rem;
  border-bottom: 1px solid ${THEME.BORDER};
`;
const Branch = styled.div `
  cursor: pointer;
  padding: 0.5rem;
  border-bottom: 1px solid ${THEME.BORDER};

  &::after {
    content: '>';
    margin-left: 0.5rem;
  }
`;
export default TreeSelect;
//# sourceMappingURL=TreeSelect.js.map